/**
 * @generated SignedSource<<ee136424beb59d7bf34c48ead9ce33b4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SideNavUserMenuQuery$variables = Record<PropertyKey, never>;
export type SideNavUserMenuQuery$data = {
  readonly viewer: {
    readonly me: {
      readonly apps: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly email: string;
      readonly firstName: string;
      readonly hubspotContactId: string;
      readonly id: string;
      readonly imageUrl: string | null | undefined;
      readonly incomingAppRequests: ReadonlyArray<{
        readonly __typename: "AppTransferRequest";
      }>;
      readonly incomingOrganizationInvitations: ReadonlyArray<{
        readonly acceptedAt: string | null | undefined;
        readonly id: string;
        readonly rejectedAt: string | null | undefined;
      }>;
      readonly lastName: string;
      readonly organizations: ReadonlyArray<{
        readonly id: string;
        readonly incomingAppRequests: ReadonlyArray<{
          readonly __typename: "AppTransferRequest";
        }>;
        readonly ownershipChangeRequest: {
          readonly toMember: {
            readonly id: string;
            readonly user: {
              readonly id: string;
            };
          };
        } | null | undefined;
      }>;
    } | null | undefined;
    readonly organizations: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly apps: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly id: string;
        };
      }>;
      readonly totalCount: number;
    };
  };
};
export type SideNavUserMenuQuery = {
  response: SideNavUserMenuQuery$data;
  variables: SideNavUserMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*:: as any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "App",
  "kind": "LinkedField",
  "name": "apps",
  "plural": true,
  "selections": (v1/*:: as any*/),
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AppTransferRequest",
  "kind": "LinkedField",
  "name": "incomingAppRequests",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hubspotContactId",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organizations",
            "plural": true,
            "selections": [
              (v0/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationOwnershipChangeRequest",
                "kind": "LinkedField",
                "name": "ownershipChangeRequest",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "toMember",
                    "plural": false,
                    "selections": [
                      (v0/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v1/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Invitation",
            "kind": "LinkedField",
            "name": "incomingOrganizationInvitations",
            "plural": true,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rejectedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "acceptedAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "OrganizationConnection",
        "kind": "LinkedField",
        "name": "organizations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OrganizationEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SideNavUserMenuQuery",
    "selections": (v4/*:: as any*/),
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SideNavUserMenuQuery",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "cacheID": "77692db027f5ba6ddbec1dcbb14b48f7",
    "id": null,
    "metadata": {},
    "name": "SideNavUserMenuQuery",
    "operationKind": "query",
    "text": "query SideNavUserMenuQuery {\n  viewer {\n    me {\n      id\n      firstName\n      lastName\n      imageUrl\n      email\n      hubspotContactId\n      apps {\n        id\n      }\n      organizations {\n        id\n        incomingAppRequests {\n          __typename\n        }\n        ownershipChangeRequest {\n          toMember {\n            id\n            user {\n              id\n            }\n          }\n        }\n      }\n      incomingAppRequests {\n        __typename\n      }\n      incomingOrganizationInvitations {\n        id\n        rejectedAt\n        acceptedAt\n      }\n    }\n    organizations {\n      totalCount\n      edges {\n        node {\n          id\n          apps {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8dfd3fad695370c4772fc5f027c34de3";

export default node;
